"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBookingAvailabilityByBorough = void 0;
/**
 * Returns the next available booking date for the supplied borough
 */
var getBookingAvailabilityByBorough = function (instance) { return function (borough, config) {
    return instance.get("/jobs/weee-kerbside/availability/".concat(borough), config);
}; };
exports.getBookingAvailabilityByBorough = getBookingAvailabilityByBorough;
